var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contentautPay" },
    [
      _c(
        "van-row",
        { staticClass: "billList" },
        [
          _c("van-col", { staticClass: "cardBar", attrs: { span: "24" } }),
          _vm._v(" "),
          _c(
            "van-col",
            { staticClass: "billBox", attrs: { span: "24" } },
            [
              _vm._l(_vm.UserNotpayList, function(item, index) {
                return _vm.UserNotpayList != 0 && item.defaultFlag == 1
                  ? _c(
                      "van-row",
                      { key: "info2-" + index, staticClass: "billBar" },
                      [
                        _c(
                          "van-col",
                          { staticClass: "title", attrs: { span: "24" } },
                          [
                            _c("van-col", { attrs: { span: "18" } }, [
                              _c("i", { staticClass: "icon" }),
                              _vm._v(
                                _vm._s(item.heatingYear) +
                                  "年度热费\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "van-col",
                              { attrs: { span: "6" } },
                              [
                                _c(
                                  "van-tag",
                                  {
                                    staticClass: "tag",
                                    attrs: {
                                      color: "#7e8c8d",
                                      round: "",
                                      plain: ""
                                    }
                                  },
                                  [_vm._v(_vm._s(item.tag))]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "van-col",
                          { staticClass: "cont", attrs: { span: "24" } },
                          [
                            _c(
                              "van-col",
                              { staticClass: "address", attrs: { span: "24" } },
                              [_vm._v(_vm._s(item.roomInfo.address))]
                            ),
                            _vm._v(" "),
                            _c(
                              "van-col",
                              {
                                staticClass: "bill-money",
                                attrs: { span: "18" }
                              },
                              [
                                _vm._v("待缴金额（元）："),
                                _c("span", { staticClass: "orange money" }, [
                                  _vm._v("¥" + _vm._s(item.allSumMoney))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "van-col",
                              { staticClass: "payBtn", attrs: { span: "6" } },
                              [
                                item.allSumMoney != 0
                                  ? _c(
                                      "van-button",
                                      {
                                        staticClass: "solidBtn",
                                        attrs: { round: "", type: "danger" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.paymentBtn(
                                              item.roomInfo.roomId
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("去缴费")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.allSumMoney == 0
                                  ? _c(
                                      "van-button",
                                      {
                                        staticClass: "hollowBtn",
                                        attrs: { round: "", type: "danger" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.gotoPath(
                                              "/reportrepair",
                                              item.roomInfo
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("去报修")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm._l(_vm.UserNotpayList, function(item, index) {
                return _vm.UserNotpayList != 0 && item.defaultFlag == 0
                  ? _c(
                      "van-row",
                      { key: index, staticClass: "billBar" },
                      [
                        _c(
                          "van-col",
                          { staticClass: "title", attrs: { span: "24" } },
                          [
                            _c("van-col", { attrs: { span: "18" } }, [
                              _c("i", { staticClass: "icon" }),
                              _vm._v(
                                _vm._s(item.heatingYear) +
                                  "年度热费\n            "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "van-col",
                              { attrs: { span: "6" } },
                              [
                                _c(
                                  "van-tag",
                                  {
                                    staticClass: "tag",
                                    attrs: {
                                      color: "#7e8c8d",
                                      round: "",
                                      plain: ""
                                    }
                                  },
                                  [_vm._v(_vm._s(item.tag))]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "van-col",
                          { staticClass: "cont", attrs: { span: "24" } },
                          [
                            _c(
                              "van-col",
                              { staticClass: "address", attrs: { span: "24" } },
                              [_vm._v(_vm._s(item.roomInfo.address))]
                            ),
                            _vm._v(" "),
                            _c(
                              "van-col",
                              {
                                staticClass: "bill-money",
                                attrs: { span: "18" }
                              },
                              [
                                _vm._v("待缴金额（元）："),
                                _c("span", { staticClass: "orange money" }, [
                                  _vm._v("¥" + _vm._s(item.allSumMoney))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "van-col",
                              { staticClass: "payBtn", attrs: { span: "6" } },
                              [
                                item.allSumMoney != 0
                                  ? _c(
                                      "van-button",
                                      {
                                        staticClass: "solidBtn",
                                        attrs: { round: "", type: "danger" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.paymentBtn(
                                              item.roomInfo.roomId
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("去缴费")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.allSumMoney == 0
                                  ? _c(
                                      "van-button",
                                      {
                                        staticClass: "hollowBtn",
                                        attrs: { round: "", type: "danger" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.gotoPath(
                                              "/reportrepair",
                                              item.roomInfo
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("去报修")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "van-col",
            { attrs: { span: "24" } },
            [
              _vm.UserNotpayList == 0
                ? _c(
                    "van-row",
                    { staticClass: "noPayBar", attrs: { span: "24" } },
                    [
                      _c("van-col", {
                        staticClass: "noPayPC",
                        attrs: { span: "24" }
                      }),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text1 orange", attrs: { span: "24" } },
                        [_vm._v("未查询到默认地址！")]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.UserNotpayList == 0
                ? _c(
                    "van-col",
                    {
                      staticClass: "barBtn",
                      attrs: {
                        span: "24",
                        type: "flex",
                        justify: "space-between"
                      }
                    },
                    [
                      _c(
                        "van-button",
                        {
                          staticClass: "btn",
                          attrs: { round: "", type: "danger", size: "large" },
                          on: {
                            click: function($event) {
                              return _vm.addPayAddress("/addressmanage")
                            }
                          }
                        },
                        [_vm._v("添加地址")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-action-sheet",
        {
          attrs: { title: "确认付款" },
          model: {
            value: _vm.isPayShow,
            callback: function($$v) {
              _vm.isPayShow = $$v
            },
            expression: "isPayShow"
          }
        },
        [
          _c(
            "van-row",
            { staticClass: "PayPop" },
            [
              _c("van-col", { staticClass: "money", attrs: { span: "24" } }, [
                _vm._v("总缴纳金额（元）")
              ]),
              _vm._v(" "),
              _c("van-col", { staticClass: "money", attrs: { span: "24" } }, [
                _c("span", { staticClass: "orange" }, [
                  _vm._v(_vm._s(_vm.payInfo.allSumMoney))
                ])
              ]),
              _vm._v(" "),
              _c("van-col", { staticClass: "Ptext1", attrs: { span: "12" } }, [
                _vm._v("缴费")
              ]),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "Ptext2 textR", attrs: { span: "12" } },
                [_vm._v(_vm._s(_vm.payInfo.companyName))]
              ),
              _vm._v(" "),
              _c("van-col", { staticClass: "Ptext1", attrs: { span: "12" } }, [
                _vm._v("付款方式")
              ]),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "Ptext2 textR", attrs: { span: "12" } },
                [_vm._v("微信")]
              ),
              _vm._v(" "),
              _c(
                "van-col",
                {
                  staticClass: "barBtn",
                  attrs: { span: "24", type: "flex", justify: "space-between" }
                },
                [
                  _c(
                    "van-button",
                    {
                      staticClass: "btn",
                      attrs: { round: "", type: "danger", size: "large" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.confirmPayment()
                        }
                      }
                    },
                    [_vm._v("确认并付款")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e373d13", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e373d13","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Payment/AutPayment.vue
// module id = null
// module chunks = 